import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
const currentPath = window.location.pathname;

export async function fetchLicenseRRR(licenseId) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  };

  const url = `${baseUrl}/v2/license/license/${licenseId}/generate-rrr`;

  const retryLimit = 5;

  for (let i = 0; i < retryLimit; i++) {
    try {
      const responseJson = await axios.post(url, null, { headers: headers });
      const response = responseJson.data;

      if (response.rrrGenerated) {
        localStorage.setItem("rrr", response.rrr);
        return response.rrr;
      }
    } catch (error) {
      console.log("error retrieving rrr", error);
    }
  }

  // only retry fetching RRR only `retryLimit`
  // times else pop-up modal and route to dashboard
  Swal.fire({
    title: "Error",
    text: "Unable to retrieve your RRR. Please Contact the administrator for assistance.",
    icon: "error",
    confirmButtonText: "OK",
  }).then(() => {
    window.location.href = `${currentPath}#/dashboard`;
  });

  return false;
}

export async function makeLicensePayment(licenseId, rrr) {
  if (!rrr) rrr = await fetchLicenseRRR(licenseId, rrr);

  const url = `${baseUrl}/v2/remita/checkRRRStatus/${rrr}`;

  try {
    const response = await axios.put(url);
    const statusCheckResponse = response.data;

    if (!statusCheckResponse || statusCheckResponse.isSuccessful === false) {
      const msg =
        statusCheckResponse?.message ??
        "Unable to contact Remita. Please try again.";
      Swal.fire({
        title: "Error",
        text: msg,
        icon: "error",
        confirmButtonText: "OK",
      });

      return;
    }

    switch (statusCheckResponse.paymentStatus) {
      case "complete":
        window.location.href = `${currentPath}#/dashboard`;
        window.location.reload();
        break;
      case "pending_confirmation":
        window.location.href = `${currentPath}#/pending-payment`;
        break;
      case "failed":
        let reason =
          statusCheckResponse?.remitaMessage?.toLowerCase() ??
          "reason was not specified.";
        Swal.fire({
          title: "Error",
          text: "Remita failed to launch! Reason cited: '" + reason + "'",
          icon: "error",
          confirmButtonText: "OK",
        });
        break;
      default:
        var paymentEngine = window.RmPaymentEngine.init({
          key: process.env.REACT_APP_REMITA_KEY,
          processRrr: true,
          transactionId: uuidv4(),
          extendedData: {
            customFields: [
              {
                name: "rrr",
                value: statusCheckResponse.RRR,
              },
            ],
          },
          onSuccess: (res) => {
            localStorage.setItem("paymentSuccessful", res);
            window.location.reload();
          },
          onError: (error) => console.error(error),
          onClose: () => {},
        });

        paymentEngine.openIframe();
    }
  } catch (error) {
    console.error(error);
    Swal.fire({
      title: "Error",
      text: "Failed to initialize payment. Please try again later.",
      icon: "error",
      confirmButtonText: "OK",
    }).then(() => {
      window.location.reload();
    });
  }
}

export function makePayment(paymentType, endpoint) {
  const rrr = localStorage.getItem("rrr");

  // Validate RRR format for all payment types (Gap 6 fix)
  // Remita RRRs are typically 12-15 digits
  if (!rrr || !/^\d{12,15}$/.test(rrr)) {
    Swal.fire({
      title: "Error",
      text: "Invalid payment reference. Please restart your registration or contact support.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return;
  }

  const url = `${baseUrl}/v2/remita/checkRRRStatus/${rrr}`;

  fetch(url, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => await res.json())
    .then((res) => {
      if (res?.paymentStatus === "complete") {
        window.location.href = `${currentPath}#/dashboard`;
        window.location.reload();
      } else {
        const statusCheckResponse = res;

        if (
          !statusCheckResponse ||
          statusCheckResponse.isSuccessful === false
        ) {
          Swal.fire({
            title: "Error",
            text:
              statusCheckResponse?.message ??
              "Unable to contact Remita. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });

          return;
        }

        if (statusCheckResponse?.paymentStatus === "pending_confirmation") {
          window.location.href = `${currentPath}#/pending-payment`;
        } else if (statusCheckResponse?.paymentStatus === "failed") {
          let reason =
            statusCheckResponse?.remitaMessage?.toLowerCase() ??
            "reason was not specified.";
          Swal.fire({
            title: "Error",
            text: "Remita failed to launch. Reason cited: '" + reason + "'",
            icon: "error",
            confirmButtonText: "OK",
          });

          return;
        } else {
          var paymentEngine = window.RmPaymentEngine.init({
            key: process.env.REACT_APP_REMITA_KEY,
            processRrr: true,
            transactionId: uuidv4(),
            extendedData: {
              customFields: [
                {
                  name: "rrr",
                  value: statusCheckResponse.RRR,
                },
              ],
            },
            onSuccess: (response) => {
              localStorage.setItem("paymentSuccessful", response, true);
              if (paymentType === "registration") {
                checkRegistrationPaymentStatus(endpoint);
              }
            },
            onError: (error) => {
              console.warn("callback onError", error);
            },
            onClose: () => {},
          });

          paymentEngine.openIframe();
        }
      }
    });
}

const checkRegistrationPaymentStatus = async (endpoint) => {
  try {
    const res = await axios.post(
      `${baseUrl}/v2/registration/register/${endpoint}`,
      { userId: JSON.parse(sessionStorage.getItem("registration:userId")) }
    );

    if (res?.data?.paymentInformation?.paymentStatus === "complete") {
      window.location.href = `${currentPath}#/dashboard`;
      window.location.reload();
    } else if (
      res?.data?.paymentInformation?.paymentStatus === "pending_confirmation"
    ) {
      window.location.href = `${currentPath}#/pending-payment`;
    }
  } catch (error) {
    if (error?.response?.data?.paymentStatus === "pending_payment") {
      Swal.fire({
        title: "Error",
        text: "Pls proceed to payment",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: "Error",
        text:
          `Payment ${error?.response?.data?.paymentStatus}` ||
          "Contact the administrator",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  }
};
